import * as pm from '@tarslib/collection';
import { PropertyList } from '@tarslib/collection';
import { lodash } from '@tarslib/collection/lib/util';
import HttpItem from './HttpItem.js';
import SocketItem from './SocketItem.js';
import WebSocketItem from './WebSocketItem.js';
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _createNewGroupOrItem(item) {
  var _item;
  if (HttpItem.isHttpItem(item) || SocketItem.isSocketItem(item) || ItemGroup.isItemGroup(item)) {
    return item;
  }
  if (pm.Item.isItem(item) || pm.ItemGroup.isItemGroup(item)) {
    // @ts-ignore
    item = item.toJSON();
  }
  // @ts-ignore
  if ((_item = item) !== null && _item !== void 0 && _item.item) {
    return new ItemGroup(item);
    // @ts-ignore
  }
  if (item.type === 'socket') {
    return new SocketItem(item);
  }
  if (item.type === 'webSocket') {
    return new WebSocketItem(item);
  }
  return new HttpItem(item);
}
var ItemGroup = /*#__PURE__*/function (_pm$ItemGroup) {
  function ItemGroup(definition) {
    var _this;
    _classCallCheck(this, ItemGroup);
    // @ts-ignore
    _this = _callSuper(this, ItemGroup, [definition]);
    _this.items = new PropertyList(_createNewGroupOrItem, _this, definition && definition.item);
    return _this;
  }
  _inherits(ItemGroup, _pm$ItemGroup);
  return _createClass(ItemGroup, null, [{
    key: "isItemGroup",
    value: function isItemGroup(obj) {
      return Boolean(obj) && (obj instanceof ItemGroup || lodash.inSuperChain(obj.constructor, '_postman_propertyName', ItemGroup._postman_propertyName));
    }
  }]);
}(pm.ItemGroup);
_defineProperty(ItemGroup, "_postman_propertyName", 'ItemGroup');
_defineProperty(ItemGroup, "_createNewGroupOrItem", _createNewGroupOrItem);
export { ItemGroup as default };
